// extracted by mini-css-extract-plugin
module.exports = {"offline-instruction":"_1nl6U","offlineInstruction":"_1nl6U"};